import { Box, Button, Card, Container, Grid, Stack, Table, TableBody, TableContainer, Typography } from '@mui/material';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import AddButton from 'src/components/Button.js/AddBotton';
import ButtonAction from 'src/components/Button.js/SaveButton';
import EmtyData from 'src/components/emty-data';
import Iconify from 'src/components/iconify';
import ComboBox from 'src/components/Input/ComboBox';
import DatePickerValue from 'src/components/Input/DatePickerValue';
import TextInput from 'src/components/Input/TextInput';
import Loader from 'src/components/loader/loader';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import Item from './ItemRequest/Item';
import AddDevices from './add/add';
import RejectRequest from '../approveRequest/modal/rejectRequest';
import DrawerSidebar from './modal/DrawerSidebar';
import ImageQRCodeModal from 'src/components/modal/ImageQRCodeModal';
import ChangeDevice from './modal/ChangeDevice';
import TakeDevice from './modal/TakeDevice';
import FindRequestWithCode from './modal/FindRequestWithCode';
import { useDownloadExcel } from 'react-export-table-to-excel';
import PutDevice from './modal/PutDevice';

const STATUS_COLOR = {
    0: 'secondary',
    1: 'primary',
    2: 'info',
    3: 'warning',
    4: 'error',
    5: 'info',
    6: 'warning',
    7: 'success',
};

const RequestDevices = () => {
    const { t } = useTranslation();
    const getRef = useRef(false);
    const isEdit = useRef(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [openRowIndex, setOpenRowIndex] = useState(null);
    const changeStatusRef = useRef(false);

    const [openDrawerSidebar, setOpenDrawerSidebar] = useState(false);
    const [openChangeRequestDevice, setOpenChangeRequestDevice] = useState(false);
    const [visiblePutDevice, setVisiblePutDevice] = useState(false);
    const dataRowSelect = useRef(null);
    const [visibleImageQR, setVisibleImageQR] = useState(false);

    const [visible, setVisible] = useState(false);
    const [visibleReject, setVisibleReject] = useState(false);
    const [visibleTakDevice, setVisibleTakDevice] = useState(false);
    const [visibleFindRequestByCode, setVisibleFindRequestByCode] = useState(false);
    const lastIdRef = useRef(0);
    const dataRef = useRef(null);
    const dataTakeRef = useRef(null);
    const getOneRef = useRef(null);
    const [totalData, setTotalData] = useState(0);

    const [dataCreateNew, setDataCreateNew] = useState([]);
    const valueSearch = useRef({
        key: '',
        startDay: moment().subtract(1, 'months').format('YYYYMMDD'),
        endDay: moment().format('YYYYMMDD'),
        status: 'all',
    });
    const user = glb_sv.userInfo;
    const isAdmin = user?.group_user === '1';
    const tableRef = useRef(null);
    const handleOnChange = (e, key) => {
        valueSearch.current[key] = e;
    };
    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [
            9999999999999,
            valueSearch.current.key?.trim(),
            valueSearch.current.status,
            valueSearch.current.startDay,
            valueSearch.current.endDay,
        ];
        sendRequest(serviceList.getListRequestDevice, InVal, getDataResult, true, timeOutFunct, 15000);
    }, [valueSearch]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log('group permission', message.proc_data.rows[1].o_1[0][0])
            setTableData(message.proc_data.rows[0].o_1);
            setTotalData(message.proc_data.rowTotal || 0);
            lastIdRef.current =
                message.proc_data.rows[0].o_1[message.proc_data.rows[0].o_1.length - 1]?.id || 99999999999;
            // console.log('🚀 ~ file: GroupDevice.js:66 ~ getDataResult ~ arr:', arr);
            dataTakeRef.current = null;
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const getDataNext = (lastId = lastIdRef.current) => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [lastId, valueSearch.key?.trim(), valueSearch.status, valueSearch.startDay, valueSearch.endDay];
        sendRequest(serviceList.getListRequestDevice, InVal, getDataNextResult, true, timeOutFunct, 15000);
    };

    // region getDataNextResult
    const getDataNextResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataRes = message.proc_data.rows[0]?.o_1 || [];
            if (dataRes?.length) lastIdRef.current = dataRes[dataRes.length - 1]?.id;
            setTableData([...tableData, ...dataRes]);
            setTotalData(message.proc_data.rowTotal || 0);
        }
    };

    const changeStatus = useCallback(
        (id, status, note_reject) => {
            if (changeStatusRef.current) {
                return;
            }
            changeStatusRef.current = true;
            setGetFlags(true);
            const InVal = [id, status];
            if (note_reject) {
                InVal.push(note_reject);
            }
            sendRequest(serviceList.changeStatusRequestDevice, InVal, changeStatusResult, true, timeOutFunct, 15000);
        },
        [valueSearch]
    );

    const changeStatusResult = (reqInfoMap, message) => {
        changeStatusRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
        }
    };

    const handleGetOne = (code) => {
        if (getOneRef.current) {
            return;
        }
        getOneRef.current = true;
        setGetFlags(true);
        const InVal = [code];
        sendRequest(serviceList.getOneRequestDevice, InVal, getOneResult, true, timeOutFunct, 15000);
    };

    const getOneResult = (reqInfoMap, message) => {
        getOneRef.current = false;
        setGetFlags(false);
        setVisibleFindRequestByCode(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataRes = message.proc_data.rows[0] || [];
            if (!dataRes?.o_14 || dataRes?.o_14?.length == 0) {
                toast.error(t('not_found_device_with_code_request'));
            }

            setDataCreateNew(dataRes?.o_14);
            setVisible(true);
            toast.success(message['proc_message']);
        }
    };

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t('list_rq_device'),
        sheet: t('list_rq_device'),
    });

    // region ARR_STATUS
    const ARR_STATUS = [
        { label: t('all'), value: 'all' },
        { label: t('waiting_confirm'), value: '0' },
        { label: t('approved'), value: '1' },
        { label: t('is_processing'), value: '2' },
        { label: t('taken'), value: '3' },
        { label: t('cancel'), value: '4' },
    ];
    // region TABLE_HEAD
    const TABLE_HEAD = [
        { id: '', label: '', alignRight: false },
        { id: '', label: '#', alignRight: false },
        { id: 'QR', label: 'QR', alignRight: false },
        { id: 'status', label: t('status'), alignRight: false },
        { id: 'code', label: t('code_request'), alignRight: false },
        { id: 'dateRequest', label: t('dateRequest'), alignRight: false },
        { id: 'userRequest', label: t('userRequest'), alignRight: false },
        { id: 'userApproveOrReject', label: t('userApproveOrReject'), alignRight: false },
        { id: 'dateApproveReject', label: t('dateApproveReject'), alignRight: false },
        { id: 'price', label: t('price'), alignRight: false },
        { id: 'note_', label: t('note_'), alignRight: false },
        { id: 'note_reject', label: t('note_reject'), alignRight: false },

        { id: 'action', label: '', alignRight: false, stickyEnd: true },
    ];

    return (
        <>
            <Helmet>
                <title> {t('list_rq_device')}</title>
            </Helmet>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('list_rq_device')}
                    </Typography>
                    <Box display={'flex'} gap={1} flexDirection={'row'}>
                        {/* <Button
                            variant="contained"
                            startIcon={<Iconify icon="mdi:content-copy" />}
                            onClick={() => {
                                setVisibleFindRequestByCode(true);
                            }}
                        >
                            {t('copy_old_request')}
                        </Button> */}
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="mingcute:file-export-line" />}
                            onClick={onDownload}
                        >
                            {t('export_excel')}
                        </Button>
                    </Box>
                </Stack>{' '}
                <Breadcrumb paths={[{ label: t('list_rq_device'), url: '#', navigate: false }]} />
                <Loader loading={getFlags} />
                <RejectRequest
                    changeStatus={changeStatus}
                    visible={visibleReject}
                    setVisible={setVisibleReject}
                    callBackFunct={() => {
                        setVisibleReject(false);
                        getData();
                    }}
                    data={dataRef.current}
                ></RejectRequest>
                <ImageQRCodeModal
                    visible={visibleImageQR}
                    setVisible={setVisibleImageQR}
                    valueImageQR={dataRef.current?.code}
                    valueCodeDevice={dataRef?.current?.code}
                    valueNameDevice={dataRef?.current?.code}
                    isRequestDeice={true}
                />
                {dataRowSelect && openDrawerSidebar && (
                    <DrawerSidebar
                        getData={getData}
                        dataRowSelect={dataRowSelect?.current?.bussiness}
                        idDeviceRequests={dataRowSelect?.current?.id}
                        device={dataRowSelect?.current?.device}
                        bussiness={dataRowSelect?.current?.bussiness}
                        noteDeviceRequests={dataRowSelect?.current?.note}
                        open={openDrawerSidebar}
                        setOpen={setOpenDrawerSidebar}
                    />
                )}
                {
                    <ChangeDevice
                        visible={openChangeRequestDevice}
                        setVisible={setOpenChangeRequestDevice}
                        data={dataRowSelect.current}
                        callBackFunct={() => {
                            getData();
                            setOpenChangeRequestDevice(false);
                        }}
                    />
                }
                <PutDevice
                    visible={visiblePutDevice}
                    setVisible={setVisiblePutDevice}
                    data={dataRowSelect.current}
                    callBackFunct={() => {
                        getData();
                        setVisiblePutDevice(false);
                    }}
                />
                <Card>
                    <Grid padding={'20px 10px'} container spacing={1} style={{}}>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <TextInput
                                size="medium"
                                getValue={(e) => handleOnChange(e, 'key')}
                                label={t('search_request')}
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <ComboBox
                                label={t('filter_status')}
                                sizeCbb="medium"
                                displayLabel="label"
                                valueEqual="value"
                                getValue={(e) => handleOnChange((e || {})['value'] || 'all', 'status')}
                                selectOption={ARR_STATUS}
                                required
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue
                                label={t('start_day')}
                                valueChange={valueSearch.current.startDay}
                                getValue={(e) => handleOnChange(e, 'startDay')}
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue
                                label={t('to_day')}
                                valueChange={valueSearch.current.toDay}
                                getValue={(e) => handleOnChange(e, 'endDay')}
                            />
                        </Grid>
                        <Grid item xl={2} md={2} sm={12} style={{ width: '100%', marginTop: 9 }}>
                            <ButtonAction
                                fullWidth
                                onClick={getData}
                                size="large"
                                type={'search'}
                                title={t('search')}
                                sx={{ padding: 3.3 }}
                            />
                        </Grid>
                    </Grid>

                    <Stack sx={{ maxHeight: '70vh' }}>
                        <TableContainer>
                            <Table>
                                <DepartmentListHead
                                    order={'asc'}
                                    orderBy={'name'}
                                    headLabel={TABLE_HEAD}
                                    rowCount={tableData.length}
                                />
                                <TableBody>
                                    {tableData.length > 0 &&
                                        tableData?.map((item, index) => {
                                            return (
                                                <Item
                                                    key={index}
                                                    item={item}
                                                    index={index}
                                                    dataRef={dataRef}
                                                    dataTakeRef={dataTakeRef}
                                                    STATUS_COLOR={STATUS_COLOR}
                                                    setVisibleReject={setVisibleReject}
                                                    openRowIndex={openRowIndex}
                                                    setOpenRowIndex={setOpenRowIndex}
                                                    dataRowSelect={dataRowSelect}
                                                    setOpenDrawerSidebar={setOpenDrawerSidebar}
                                                    setVisibleImageQR={setVisibleImageQR}
                                                    setOpenChangeRequestDevice={setOpenChangeRequestDevice}
                                                    setVisibleTakDevice={setVisibleTakDevice}
                                                    setDataCreateNew={setDataCreateNew}
                                                    setVisible={setVisible}
                                                    handleGetOne={handleGetOne}
                                                    setVisiblePutDevice={setVisiblePutDevice}
                                                />
                                            );
                                        })}
                                </TableBody>
                            </Table>
                            {tableData.length === 0 && <EmtyData />}
                        </TableContainer>
                        <Box
                            sx={{ position: 'sticky', zIndex: 1000, bottom: 0, backgroundColor: '#f1f3f4' }}
                            display={'flex'}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            paddingLeft={2}
                            // paddingRight={2}
                        >
                            <Stack>
                                <span>
                                    {t('total_row')}: {tableData.length}/{totalData}
                                </span>
                            </Stack>
                            <Button
                                variant="contained"
                                endIcon={<Iconify icon="material-symbols:skip-next-rounded" />}
                                onClick={() => getDataNext()}
                                disabled={tableData.length < totalData ? false : true}
                            >
                                {t('next')}
                            </Button>
                        </Box>
                    </Stack>

                    {/* table xuất excel */}
                    <TableContainer>
                        <Table ref={tableRef} sx={{ display: 'none' }}>
                            <DepartmentListHead
                                order={'asc'}
                                orderBy={'name'}
                                headLabel={TABLE_HEAD}
                                rowCount={tableData.length}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData?.map((item, index) => {
                                        return (
                                            <Item
                                                key={index}
                                                item={item}
                                                index={index}
                                                dataRef={dataRef}
                                                dataTakeRef={dataTakeRef}
                                                STATUS_COLOR={STATUS_COLOR}
                                                setVisibleReject={setVisibleReject}
                                                openRowIndex={openRowIndex}
                                                setOpenRowIndex={setOpenRowIndex}
                                                dataRowSelect={dataRowSelect}
                                                setOpenDrawerSidebar={setOpenDrawerSidebar}
                                                setVisibleImageQR={setVisibleImageQR}
                                                setOpenChangeRequestDevice={setOpenChangeRequestDevice}
                                                setVisibleTakDevice={setVisibleTakDevice}
                                                setDataCreateNew={setDataCreateNew}
                                                setVisible={setVisible}
                                                handleGetOne={handleGetOne}
                                            />
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
                <AddButton
                    onClick={() => {
                        isEdit.current = false;
                        setVisible(true);
                        // setData({});
                    }}
                />
            </Container>

            <AddDevices
                visible={visible}
                setVisible={setVisible}
                callBack={() => {
                    getData();
                    setVisible(false);
                }}
                dataCreateNew={dataCreateNew}
                setDataCreateNew={setDataCreateNew}
            />
            <TakeDevice
                visible={visibleTakDevice}
                setVisible={setVisibleTakDevice}
                callBackFunct={() => {
                    getData();
                    setVisibleTakDevice(false);
                }}
                data={dataTakeRef.current}
            />
            {/* <FindRequestWithCode
                visible={visibleFindRequestByCode}
                setVisible={setVisibleFindRequestByCode}
                callBackFunct={() => {}}
                handleGetOne={handleGetOne}
            /> */}
        </>
    );
};

export default RequestDevices;
